<template>
  <!--
    name: 覃刚
    function: 列表结构页面
    date: 2021-03-03
 -->
  <div class="appBox">
    <page-menu />
    <header class="headBox">
      <div
        style="
          line-height: 79px;
          padding: 0px 20px;
          margin-top: -4px;
          background: #1577ff;
        "
      >
        <a-icon
          :type="menuVisible ? 'close' : 'menu-unfold'"
          style="font-size: 21px; color: #fff"
          @click="showMenu"
        />
      </div>

      <a-layout-sider
        width="140"
        theme="light"
        :class="['logoImg', collapsed && 'collapsed']"
      >
        <img class="logo" :src="logo" />
      </a-layout-sider>
      <div style="line-height: 64px"><a-divider type="vertical" /></div>
      <a-breadcrumb style="margin-bottom: 15px; line-height: 64px">
        <a-breadcrumb-item v-for="(item, ind) in nameArr" :key="item">
          <a @click="clickBread(ind, item)">
            {{ item || "" }}
          </a>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="userBox">
        <div style="position: absolute; right: 0; top: 15px; display: flex">
          <div style="margin-top: 5px">
            <!-- <a-select
              style="width: 200px;margin-left:10px"
              @change="handleChange"
              v-model="factoryValue"
              show-search
              :filter-option="filterOption"
            >
              <a-select-option v-for="item in factoryData" :key="item.factoryId"  >
                <a-tooltip>
                  <template #title>{{item.name}}</template>
                  {{item.name}}
                </a-tooltip>
              </a-select-option>
            </a-select> -->
            <a-popover trigger="click" placement="bottom">
              <template slot="content">
                <div
                  style="
                    padding: 10px 0;
                    margin-bottom: 10px;
                    border-bottom: 1px solid #e5e5e5;
                  "
                >
                  <!-- <a-input-search placeholder="请输入工厂名称" style="width: 240px;" enter-button="搜索" @pressEnter="filterFactory" v-model="searchKey" @search="filterFactory" /> -->
                  <a-input
                    v-model="searchKey"
                    @pressEnter="filterFactory"
                    placeholder="工厂名称"
                    style="width: 185px; margin-right: 10px"
                  >
                    <a-icon slot="prefix" type="search" />
                  </a-input>
                  <a-button
                    @click="filterFactory"
                    type="primary"
                    style="position: relative; top: -1px"
                    >搜索</a-button
                  >
                </div>
                <div
                  v-for="item in filterFactoryList"
                  :key="item.factoryId"
                  class="factoryNameText"
                  :class="{ factoryChoice: item.factoryId === factoryValue }"
                  @click="handleChange(item.factoryId)"
                >
                  <a-tooltip>
                    <template slot="title">
                      {{ item.name }}
                    </template>
                    {{ item.name }}
                  </a-tooltip>
                </div>
                <!-- <p>000</p> -->
              </template>
              <span type="primary">
                {{ factoryName }}
                <a-icon type="down" style="margin-left: 5px; font-size: 12px" />
              </span>
            </a-popover>
          </div>
          <div style="padding-top: 8px; margin: 0 10px">
            <a-divider type="vertical" />
          </div>
          <a-tooltip size="small">
            <a-icon
              type="cloud"
              style="font-size: 18px; padding-right: 20px; padding-top: 7px"
              @click="jump"
            />
            <template slot="title">进入云平台</template>
          </a-tooltip>
          <a-tooltip size="small">
            <a-badge class="msgStyle" :dot="isUpdate" @click="getUpdate(true)">
              <a-icon type="bell" style="font-size: 18px" />
            </a-badge>
            <template slot="title">更新工厂原料价格</template>
          </a-tooltip>
          <a-popover v-model="visible" trigger="click" class="userImg">
            <div slot="content">
              <!-- <div class="userInfo">
                <p>{{userName}}</p>
                <p style="white-space: nowrap;">{{factoryName}}</p>
              </div> -->
              <div style="margin-bottom: 10px">
                <a @click="hide">退出登录</a>
              </div>
              <div style="margin-bottom: 10px">
                <a @click="turnToMyMsg">个人中心</a>
              </div>
              <div><a @click="turnToFactory">切换工厂</a></div>
            </div>
            <div>
              <!-- <a-avatar icon="user" style="float: left;margin-right: 10px;"></a-avatar> -->
              <!-- portrait -->
              <img
                :src="portraitUrl"
                style="
                  float: left;
                  margin-right: 10px;
                  width: 32px;
                  height: 32px;
                "
              />
              <!-- {{factoryName}} -->
              <p style="white-space: nowrap; float: left; margin-top: 8px">
                {{ userName }}
              </p>
            </div>
          </a-popover>
        </div>
      </div>
    </header>
    <div class="bodyBox">
      <!-- <a-layout-sider width="250" theme="light" class="menuBox" v-model="collapsed" :trigger="null" collapsible>
        <menu-list :collapsed="collapsed" v-if="list.length" :list="list"  ref="menuList" />
      </a-layout-sider> -->
      <drawer-menu :list="list" />
      <div class="contentBox">
        <!-- <a-breadcrumb style="margin-bottom:15px">
          <a-breadcrumb-item v-for="(item,ind) in nameArr" :key="item">
            <a @click="clickBread(ind,item)">
              {{item || ""}}
            </a>
          </a-breadcrumb-item>
        </a-breadcrumb> -->
        <router-view :key="overseasFlag" :btnList="btnList" />
      </div>
    </div>
    <a-modal
      title="原料数据更新"
      :visible="updateVisible"
      @ok="update"
      @cancel="closeUpdate"
      okText="确定更新"
      cancelText="取消"
      destroyOnClose
      width="900px"
    >
      <template slot="footer">
        <div style="float: left; display: flex; color: rgba(0, 0, 0, 0.85)">
          <p>
            已选中<span style="color: red">{{ selectedRowKeys.length }}</span
            >个原料
          </p>
          <a-divider type="vertical" style="top: 5px" />
          <a-form
            class="headForm"
            style="padding: 0; position: relative; top: -9px"
            :label-col="labelCol"
          >
            <a-form-item label="价格来源" style="line-height: 30px">
              <a-checkbox-group v-model="formPriceList" style="width: 100%">
                <a-checkbox
                  v-for="el in priceSource"
                  :key="el.code"
                  :value="el.code"
                  >{{ el.name }}</a-checkbox
                >
              </a-checkbox-group>
            </a-form-item>
          </a-form>
        </div>
        <div>
          <a-button @click="closeUpdate">取消</a-button>
          <a-button @click="update" type="primary">确定更新</a-button>
        </div>
      </template>
      <a-table
        bordered
        :scroll="{ y: 400 }"
        :columns="columns"
        :data-source="updateList"
        class="tableBox tableBox1"
        :row-selection="rowSelection"
        :pagination="false"
        rowKey="rawId"
      >
        <span
          v-for="item in ['privateStockPrice', 'privateMarketPrice', 'privatePredictionPrice']"
          slot-scope="text, record"
          :slot="item"
          :key="item"
        >
          <div>
            <p
              v-if="
                (record[item] || record[item] === 0) &&
                (record[getFeild(item)] || record[getFeild(item)] === 0)
              "
            >
              <span>{{ record[item].toFixed(3) }}</span
              >/
              <span
                :style="{
                  color:
                    record[item] > record[getFeild(item)] ? 'green' : 'red',
                }"
                >{{ record[getFeild(item)].toFixed(3) }}</span
              >
            </p>
            <p v-else>-</p>
          </div>
        </span>
      </a-table>
    </a-modal>

    <!-- <ns-track v-track="{eventType: 'detail', data: trackDetail}"/> -->
  </div>
</template>
<script>
// import menuList from './MenuList'
import DrawerMenu from './DrawerMenu.vue'
import { getRequest } from '../Common/Utils/Utils'
import portraitUrl from '../../assets/images/portrait.png'
import PageMenu from './PageMenu.vue'
import moment from "moment";
import { mapState, mapMutations } from 'vuex'
import { instance } from '@/Utils/axios'
import { baseUrl, adminUrl } from '@/Utils/url.js'
// import NsTrack from '@/Utils/track/track'
// import axios from 'axios'
const setTime = 4 * 60 * 60 * 1000;
export default {
  name: 'home',
  components: {
    // menuList,
    // NsTrack,
    PageMenu,
    DrawerMenu,
  },
  data() {
    return {
      trackDetail: {},
      formPriceList: [],
      priceList: [],
      helpMsg: null,
      form: this.$form.createForm(this),
      labelCol: { style: { width: '70px' } },
      priceSource: [
        { name: '库存价格', code: 1 }, { name: '市场价格', code: 2 }, { name: '预测价格', code: 3 },
      ],
      searchKey: '',
      filterFactoryList: [],
      overseasFlag: '',
      factoryData: [], //保存工厂数据
      factoryValue: window.localStorage.getItem('factoryId'),
      updateVisible: false,
      dateStr: moment(new Date()).format("YYYY-MM-DD"),
      isUpdate: false,
      portraitUrl,
      pathNameArr: [],
      type: 'home',
      nameArr: [],
      btnList: [],
      visible: false,
      collapsed: true,
      setToken: null, // 计时器
      setTime: 4 * 60 * 60 * 1000, // 刷新间隔
      // setTime: 10 * 1000, // 刷新间隔
      logoSrc: require('../../assets/images/logo.png'),
      list: [],
      menuInfor: {
        first: {},
        second: {},
        third: {},
        hierarchy: 0
      },
      updateList: [],
      selectedRowKeys: [],
      columns: [
        {
          title: '代码',
          dataIndex: 'code',
          width: 80,
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 120,
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          width: 160,
        },
        {
          // privateStockPrice 历史; ebsPrivateStockPrice 最新；
          title: '库存价格(历史/最新)',
          dataIndex: 'privateStockPrice',
          scopedSlots: { customRender: 'privateStockPrice' },
          width: 140,
        },
        {
          // privateMarketPrice 历史; ebsPrivateMarketPrice 最新 ;
          title: '市场价格(历史/最新)',
          dataIndex: 'privateMarketPrice',
          scopedSlots: { customRender: 'privateMarketPrice' },
          width: 140,
        },
        {
          // privatePredictionPrice  历史; fridayPrivatePredictionPrice  最新 ;
          title: '预测价格(历史/最新)',
          dataIndex: 'privatePredictionPrice',
          scopedSlots: { customRender: 'privatePredictionPrice' },
          width: 140,
        },
      ],
      len: 0
    }
  },
  computed: {
    ...mapState('home', ['menuVisible']),
    thirdBreadName() {
      let thirdBreadName = window.localStorage.getItem('thirdBreadName') || '客户原料管理'
      return thirdBreadName
    },
    rowSelection() {
      return {
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys
        },
        selectedRowKeys: this.selectedRowKeys,
      }
    },
    logo() {
      return this.collapsed ? require('../../assets/images/logo_nhf.svg') : require('../../assets/images/logo_nhf.svg')
    },
    userName() {
      return this.$store.state.userName || window.localStorage.getItem('userName');
    },
    factoryName() {
      return this.$store.state.factoryName || window.localStorage.getItem('factoryName');
    },
  },
  mounted() {
    // 刷新token
    let factoryId = window.localStorage.getItem('factoryId')
    let accessToken = window.localStorage.getItem('accessToken')
    let refreshToken = window.localStorage.getItem('refreshToken')
    let userName = window.localStorage.getItem('userName')
    let staffId = window.localStorage.getItem('staffId')

    let code = getRequest('code')
    let state = getRequest('state').slice(0, -2)
    let source = getRequest('source')
    if (code && state && source) {
      if (window.location.href.indexOf('/?') >= 0) {
        let src = window.location.href.split('/?')[0]
        window.location.href = `${src}/#/checkLogin?code=${code}&state=${state}&source=${source}`
      } else {
        this.$router.push(`/checkLogin?code=${code}&state=${state}&source=${source}`)
      }
    } else {
      if (!staffId || !accessToken || !refreshToken) {
        this.deleteStorage()
        this.$router.push('/login')
        return
      }
      if (accessToken && userName && userName !== 'null') {
        this.refreshToken();
        this.getUpdate();
        this.getNotification();
        if (factoryId && accessToken && refreshToken) {
          this.getMenus()
          this.getFactoryDetails(factoryId)
        } else {
          if (!factoryId) {
            this.$router.push('/factory?name=工厂选择')
          } else {
            this.getFactoryDetails(factoryId)
          }
        }
      } else {
        this.$router.push('/login')
      }
    }

    this.getFactory() //获取工厂数据
  },
  watch: {
    $route: {
      handler: function (val) {
        if (val.name === '404') {
          this.nameArr = []
          if (val.fullPath === '/') this.$router.push('/mainPage')
        } else {
          if (window.location.href.indexOf('customer-nutrient') >= 0) {
            this.dealBreadName(this.list)
          }
          this.getName()
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations('home', ['setState']),
    ...mapMutations('material', ['setCount']),
    filterFactory() {
      this.filterFactoryList = this.factoryData.filter(el => el.name.indexOf(this.searchKey) >= 0)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].elm.textContent.indexOf(input.toLowerCase()) >= 0
      );
    },
    showMenu() {
      this.setState({ menuVisible: !this.menuVisible })
    },
    getFactoryDetails(id) {
      this.$get('/iot-factory/factory/detail', { id }).then(res => {
        let { success, data } = res || {}
        if (success) {
          let { overseasFlag } = data || {}
          this.trackDetail = data || {}
          if (overseasFlag != window.localStorage.getItem('overseasFlag')) {
            this.overseasFlag = overseasFlag
            window.localStorage.setItem('overseasFlag', overseasFlag)
          }

          // 存一个工厂的详细信息
          window.localStorage.setItem('factoryDetail', JSON.stringify(data))
        }
      })
    },
    jump() {
      // let accessToken = window.localStorage.getItem('accessToken')
      // let refreshToken = window.localStorage.getItem('refreshToken')
      // let loginTime = window.localStorage.getItem('loginTime')
      // let userName = window.localStorage.getItem('userName')
      // let staffId = window.localStorage.getItem('staffId')
      // window.open(`${adminUrl}?accessToken=${accessToken}&refreshToken=${refreshToken}&loginTime=${loginTime}&userName=${userName}&staffId=${staffId}`)
      // window.open(adminUrl)

      let localUrl = instance.defaults.baseURL ? instance.defaults.baseURL : baseUrl
      let url = `${localUrl}iot-auth/oauth/render/newhope?clientUrl=${adminUrl}`
      window.open(url)
    },
    getFeild(item) {
      let el = ''
      if (item === 'privateStockPrice') el = 'ebsPrivateStockPrice'
      if (item === 'privateMarketPrice') el = 'ebsPrivateMarketPrice'
      if (item === 'privatePredictionPrice') el = 'fridayPrivatePredictionPrice'
      return el
    },
    closeUpdate() {
      this.updateVisible = false
      this.selectedRowKeys = []
      this.formPriceList = []
    },
    requestUpdate(params, key) {
      this.$http.post(`/nhf-app/factorystaffraw/updatEbsPrice?factoryId=${params.factoryId}&staffId=${params.staffId}&rawIds=${params.rawIds}&priceSource=${params.priceSource}`).then(res => {
        // this.$http.post(`/nhf-app/factorystaffraw/updatEbsPrice`,params).then(res => {
        let { success } = res
        if (success) {
          this.$message.success('更新数据成功')
          key && this.$notification.close(key)
          this.getUpdate()
          this.selectedRowKeys = []
          this.closeUpdate()
          this.setCount()
        }
      })
    },
    update() {
      if (!this.formPriceList || this.formPriceList.length === 0) {
        this.$message.warning('请选择价格来源')
        return
      }
      let factoryId = window.localStorage.getItem('factoryId')
      let staffId = window.localStorage.getItem('staffId')
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择要更新的数据')
      } else {
        let lenPrice = this.selectedRowKeys.length
        this.$confirm({
          title: '全部更新',
          content: <div>
            确认更新
            <span style="color:red;">{lenPrice}</span>个原料的
            {this.formPriceList.includes(1) ? <span style="color:red;">库存价格</span> : null}
            {this.formPriceList.length === 2 ? <span>、</span> : null}
            {this.formPriceList.includes(2) ? <span style="color:red;">市场价格</span> : null}
            ？
          </div>,
          okText: '继续',
          cancelText: '取消',
          onOk: () => {
            let len = this.selectedRowKeys.length
            let max = 150
            let num = Math.ceil(len / max)
            let priceSource = this.formPriceList ? this.formPriceList.join(',') : undefined
            let arr = Array.from({ length: num }, (v, i) => {
              let rawIdArr = this.selectedRowKeys.slice(i * max, ((i + 1) * max))
              return {
                factoryId,
                staffId,
                rawIds: rawIdArr,
                priceSource,
              }
            })
            arr && arr.forEach(params => {
              this.requestUpdate(params)
            })
          },
        });
      }
    },
    changeValue(val) {
      if (val.length === 0) {
        this.helpMsg = <span style={{ color: 'red' }}>请选择价格来源</span>
      } else {
        this.helpMsg = null
      }
    },
    openNotise() {
      let date = moment(new Date()).format("YYYY-MM-DD")
      let len = this.len
      const key = `open${Date.now()}`;
      this.priceList = []
      this.$notification.open({
        key,
        message: '请求更新原料',
        icon: <a-icon type="info-circle" style="color: #108ee9" />,
        style: {
          width: '400',
          marginLeft: `${335 - 400}px`,
        },
        description: () => {
          return (
            <div>
              <p>{date},您共有<span style="color: red">{len}</span>个原料价格与云平台不一致，是否进行更新？</p>
              <a-form class="headForm" style={{ padding: 0 }} label-col={this.labelCol}>
                <a-form-item label="价格来源" required help={this.helpMsg}>
                  <a-checkbox-group
                    v-model={this.priceList}
                    style="width: 100%;"
                    onChange={this.changeValue}
                  >
                    {
                      this.priceSource && this.priceSource.map(el => {
                        return <a-checkbox key={el.code} value={el.code}>{el.name}</a-checkbox>
                      })
                    }
                  </a-checkbox-group>
                </a-form-item>
              </a-form>
            </div>
          )
        },
        duration: 0,
        btn: h => {
          return h(
            'div', null, [
            h('a-button',
              {
                props: {
                  // type: 'primary',
                  size: 'small',
                },
                on: {
                  click: () => {
                    if (this.updateList.length === 0) {
                      this.$message.warning('当前没有可查看的数据。')
                    } else {
                      this.updateVisible = true
                      this.$notification.close(key)
                    }
                  },
                },
                style: {
                  'margin-right': '10px'
                }
              },
              '查看详情',
            ),
            h('a-button',
              {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                on: {
                  click: () => {
                    if (this.priceList.length === 0) {
                      this.$message.warning('请选择价格来源')
                      return
                    }
                    let factoryId = window.localStorage.getItem('factoryId')
                    let staffId = window.localStorage.getItem('staffId')
                    let rawIds = []
                    if (this.updateList.length === 0) {
                      this.$message.warning('当前没有可更新的数据。')
                    } else {
                      this.updateList.forEach(el => {
                        rawIds.push(el.rawId)
                      })
                      let len = rawIds.length
                      let max = 150
                      let num = Math.ceil(len / max)
                      let arr = Array.from({ length: num }, (v, i) => {
                        let rawIdArr = rawIds.slice(i * max, ((i + 1) * max))
                        return {
                          factoryId,
                          staffId,
                          rawIds: rawIdArr,
                          priceSource: this.priceList && this.priceList.length > 0 ? this.priceList.join(',') : undefined
                        }
                      })
                      arr && arr.forEach(params => {
                        this.requestUpdate(params, key)
                      })
                      setTimeout(() => {
                        this.priceList = []
                        this.selectedRowKeys = []
                      }, 100);
                      // let params = {
                      //   factoryId,
                      //   staffId,
                      //   rawIds: rawIds.join(',')
                      // }
                      // this.requestUpdate(params,key)
                    }
                  },
                },
              },
              '全部更新',
            )
          ]

          );
        },
      });
    },
    getNotification() {
      // 获取通知数据
      let staffId = window.localStorage.getItem('staffId');
      if (!staffId) return;

      this.$post('/nhf-api-center/msgnotice/getNewestMsgNoticeVO', {
        clientId: '1123598811738675201', // NHF客户端id
        staffId: Number(staffId)
      }).then(res => {
        let { success, data } = res || {};
        if (success && data) {
          // 处理通知数据
          this.openNotification(data);
        }
      });
    },
    openNotification(noticeData) {
      if (!noticeData.pushTitle) return;

      const key = `notification_${Date.now()}`;
      const { pushTitle, pushContent, appPagePath, appPageName, thirdUrl } = noticeData;

      this.$notification.open({
        key,
        message: pushTitle || '通知标题',
        description: pushContent || '通知内容',
        duration: 0,
        placement: 'topRight',
        btn: h => {
          const buttons = [];
          // 只有当URL存在时才显示查看详情按钮
          if (appPagePath || thirdUrl) {
            buttons.push(
              h('a-button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    // 标记为已读
                    this.markAsRead(noticeData.id);
                    if (appPagePath) {
                      this.$router.push(`${appPagePath}?name=${appPageName}`);
                    }
                    // 跳转到对应页面或打开链接
                    else if (thirdUrl.startsWith('http')) {
                      window.open(thirdUrl);
                    }
                    this.$notification.close(key);
                  }
                }
              }, '查看详情')
            );
          }

          return h('div', {}, buttons);
        },
        onClose: () => {
          // 关闭时标记为已读
          this.markAsRead(noticeData.id);
        }
      });
    },
    markAsRead(noticeId) {
      if (!noticeId) return;

      let staffId = window.localStorage.getItem('staffId');
      if (!staffId) return;

      this.$post('/nhf-api-center/msgnotice/viewMsgNotice', {
        id: noticeId,
        staffId: Number(staffId)
      }).then(res => {
        console.log(res);
        // 可以在这里处理标记已读的响应
      });
    },
    async getUpdate(flag) {
      let factoryId = window.localStorage.getItem('factoryId')
      let staffId = window.localStorage.getItem('staffId')
      // let factoryId = '1386613070195792196'
      // let staffId = '1414507010462904322'
      if (!factoryId || !staffId) return
      this.$http.get(`/nhf-app/factorystaffraw/myRawPriceDiffStatus?factoryId=${factoryId}&staffId=${staffId}`).then(res => {
        if (res.data && res.data.length > 0) {
          this.updateList = res.data;
          this.len = res.data.length
          setTimeout(() => {
            this.isUpdate = true
          }, 100);
        } else {
          this.updateList = [];
          this.isUpdate = false
          this.len = 0
        }

        setTimeout(() => {
          if (flag) {
            this.openNotise()
          }
        }, 0);
      })
    },
    getName() {
      let src = window.location.href;
      let paramsUrl = src.split("/#/")[1];
      let openKeysArr = []
      let name = getRequest('name')
      if (paramsUrl) {
        if (paramsUrl.indexOf('?') >= 0 && paramsUrl.split('?')[0]) {
          openKeysArr = paramsUrl.split('?')[0].split('/')
          let nameKey = openKeysArr[openKeysArr.length - 1]
          let nameArr = []
          if (this.pathNameArr[nameKey]) nameArr = JSON.parse(JSON.stringify(this.pathNameArr[nameKey]))
          nameArr.push(name)
          this.nameArr = nameArr
        }
      } else {
        this.$router.push('/factory?name=工厂选择')
      }
    },
    clickBread(hierarchy, name) {
      if (hierarchy === 0 || hierarchy === 2 || hierarchy === 3) {
        if (hierarchy == 2) {
          if (window.location.href.indexOf('customer-nutrient') >= 0) {
            let customId = getRequest('customId')
            let name = window.localStorage.getItem('thirdBreadName')
            this.$router.push(`/mainPage/customer-material?name=${name}&id=${customId}`)
          } else {
            this.$router.go(0)
          }
        } else {
          this.$router.go(0)
        }
      } else {
        let menuList = this.findMenu(this.list, name) || []
        let menu = menuList[0] || {}
        this.$router.push(`${menu.path}?name=${menu.name}`)
      }
    },
    findMenu(list, name, obj = []) {
      list.forEach(el => {
        if (el.name === name) obj.push(el)
        if (el.children) this.findMenu(el.children, name, obj)
      })
      return obj
    },
    turnToFactory() {
      this.$router.push('/factory?name=工厂选择')
    },
    turnToMyMsg() {
      this.$router.push('/system/my-message?name=我的信息')
    },
    getToken() {
      // window.localStorage.setItem("accessToken", "");
      window.localStorage.setItem("loginTime", 0);
      let refreshToken = window.localStorage.getItem("refreshToken");
      this.$post(
        "/iot-auth/token",
        `grantType=refresh_token&refreshToken=${refreshToken}&tenantId=000000`
      )
        .then(res => {
          let { success } = res;
          if (success) {
            let { accessToken } = res.data || {};
            window.localStorage.setItem("accessToken", accessToken);
            window.localStorage.setItem("loginTime", new Date().getTime());
            this.refreshStorage()
          }
          // else {
          //   this.$router.push("/login");
          // }
        });
    },
    refreshToken() {
      // 清空计时器
      this.setToken = null;
      let loginTime = window.localStorage.getItem("loginTime");
      let accessToken = window.localStorage.getItem("accessToken");
      let newTime = new Date().getTime();
      if (loginTime && accessToken) {
        if (newTime - loginTime > setTime) {
          // token超时
          this.setToken = setInterval(() => {
            this.getToken();
          }, setTime);
        } else {
          setTimeout(() => {
            this.getToken();
            this.setToken = setInterval(() => {
              this.getToken();
            }, setTime);
          }, setTime - (newTime - loginTime));
        }
      } else {
        this.$store.commit("controlLoading", false);
        this.deleteStorage()
        // setTimeout(() => {
        //   this.$router.push("/login");
        // }, 0);
      }
    },
    refreshStorage() {
      window.localStorage.setItem('staffId', window.localStorage.getItem('staffId'));
      window.localStorage.setItem('factory', window.localStorage.getItem('factory'));
      window.localStorage.setItem('overseasFlag', window.localStorage.getItem('overseasFlag'))
      window.localStorage.setItem('factoryId', window.localStorage.getItem('factoryId'));
      window.localStorage.setItem('factoryName', window.localStorage.getItem('factoryName'));
      window.localStorage.setItem('userName', window.localStorage.getItem('userName'));
    },
    deleteStorage() {
      window.localStorage.removeItem('overseasFlag')
      window.localStorage.removeItem("accessToken");
      window.localStorage.removeItem("userName");
      window.localStorage.removeItem("staffId");
      window.localStorage.removeItem("loginTime");
      window.localStorage.removeItem("refreshToken");
      window.localStorage.setItem('ssoLoginOut', true)
      window.localStorage.removeItem("factoryId");
      window.localStorage.removeItem("factory");
      window.localStorage.removeItem("factoryName");
      window.localStorage.removeItem("userInfo");
    },
    hide() {
      this.visible = false;
      // window.location.href = ''
      this.$http.get('/iot-auth/oauth/logout/newhope').then(res => {
        let { success, data } = res || {}
        if (success) {
          // 清除token userName loginOutSrc
          // window.location.href = data.url
          // this.$router.push("/login");
          this.deleteStorage()
          let src = window.location.href;
          if (src.split('/#/')[0]) {
            // let clientUrl = encodeURIComponent(src.split('/#/')[0] + '/#/checkLogin')
            // // let clientUrl = src.split('/#/')[0] + '/#/checkLogin'
            // // window.open(`${data.url}?service=${clientUrl}`, "_blank");
            // this.$router.push("/checkLogin?loginOutSrc");
            // this.deleteStorage()
            // window.localStorage.setItem('loginOutSrc',`${data.url}?service=${clientUrl}`)
            // // window.location.href = `${data.url}?service=${clientUrl}`
            let localUrl = instance.defaults.baseURL ? instance.defaults.baseURL : baseUrl
            let clientUrl = `${localUrl}iot-auth/oauth/callback/newhope`
            let clientState = window.localStorage.getItem('clientState')
            if (clientState) {
              window.localStorage.removeItem('clientState')
              window.localStorage.removeItem('clientCode')
              this.$router.push("/checkLogin?loginOutSrc");
              window.localStorage.setItem("loginOutSrc",
                `${data.url}?redirect_uri=${clientUrl}&response_type=code&client_id=dQpZsakEwHlqTMCO&scope=openid&state=${clientState}`
              );
            } else {
              this.$router.push("/login");
            }
          }
        }
      })
    },
    getMenus() {
      let factoryId = window.localStorage.getItem('factoryId')
      this.$http.get("/iot-system/menu/routes", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          let iconObj = { mainPage: 'database', core: 'database', nhf: 'dashboard', factory: 'home', fine: 'experiment', production: 'reconciliation', system: 'desktop', fast: 'bar-chart' }
          data && data.map(el => {
            el.icon = iconObj[el.code] || el.code
            return el
          })
          this.list = data || []
          this.dealBreadName(data)
          this.getName()
          let name = getRequest('name')
          if (data[0] && !name) { // 有菜单的情况
            if (data[0].children[0]) { // 第一级菜单有子级的情况
              let route = data[0].children[0]
              this.$router.push(`${route.path}?name=${route.name}`);
            }
          }
        } else {
          console.log('获取菜单失败');
        }

      });
      this.$http.get("/iot-system/menu/buttons", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          this.btnList = data || []
          this.setState({ btnList: data })
        } else {
          console.log('获取按钮权限失败');
        }

      });
    },

    dealBreadName(data = []) {
      let pathNameArr = {}
      data.forEach(el => {
        if (el.children && el.children.length > 0) {
          el.children.forEach(item => {
            // 三级菜单
            if (item.code === 'shareManagementList') {
              // 分享管理
              pathNameArr['share-product-detail'] = [el.name, item.name];
            }
            if (item.code === 'materialManagement') {
              // 营养指标管理
              pathNameArr['nutrient-list'] = [el.name, item.name]
            }
            if (item.code === 'nutritional-indicator') {
              // 营养指标管理
              pathNameArr['index-view'] = [el.name, item.name]
            }
            if (item.code === 'productList') {
              // 产品记录详情
              pathNameArr['product-detail'] = [el.name, item.name]
              pathNameArr['product-comparison'] = [el.name, item.name]
            }
            if(item.code === 'archive-data-formula'){
              pathNameArr['archive-data-compound-detail'] = [el.name, item.name]
            }
            if(item.code === 'archive-data-customized-formula'){
              pathNameArr['archive-data-customized-compound-detail'] = [el.name, item.name]
            }
            if(item.code === 'archive-data-blend'){
              pathNameArr['archive-data-blend-detail'] = [el.name, item.name]
            }
            if(item.code === 'archive-data-product-list'){
              pathNameArr['archive-data-product-detail'] = [el.name, item.name]
            }
            if(item.code === 'archive-data-customized-product-list'){
              pathNameArr['archive-data-customized-product-detail'] = [el.name, item.name]
            }
            if (item.code === 'customer-management') {
              // 客户管理-原料维护
              pathNameArr['customer-material'] = [el.name, item.name]
              let thirdBreadName = window.localStorage.getItem('thirdBreadName')
              pathNameArr['customer-nutrient'] = [el.name, item.name, thirdBreadName]
            }
            if (item.code === 'customized-productList') {
              pathNameArr['customized-product-detail'] = [el.name, item.name]
            }
            if (item.code === 'pig') {
              pathNameArr['good-news'] = [el.name, item.name]
              pathNameArr['pig-detail'] = [el.name, item.name]
              pathNameArr['pig-new-data'] = [el.name, item.name]
              pathNameArr['pig-copy-data'] = [el.name, item.name]
            }
            if (item.code === 'ruminate') {
              pathNameArr['ruminate-detail'] = [el.name, item.name]
              pathNameArr['ruminate-new-data'] = [el.name, item.name]
              pathNameArr['ruminate-copy-data'] = [el.name, item.name]
            }
            if (item.code === 'poultry') {
              pathNameArr['meat-detail'] = [el.name, item.name]
              pathNameArr['egg-detail'] = [el.name, item.name]
              pathNameArr['meat-new-data'] = [el.name, item.name]
              pathNameArr['egg-new-data'] = [el.name, item.name]
              pathNameArr['meat-copy-data'] = [el.name, item.name]
              pathNameArr['egg-copy-data'] = [el.name, item.name]
            }
            if (item.code === 'aquatic') {
              pathNameArr['fish-detail'] = [el.name, item.name]
              pathNameArr['fish-new-data'] = [el.name, item.name]
              pathNameArr['fish-copy-data'] = [el.name, item.name]
            }
            if (item.code === 'rd-result') {
              pathNameArr['rd-result-detail'] = [el.name, item.name];
            }
            let arr = item.path.split('/') || []
            let newFeild = arr[arr.length - 1]
            pathNameArr[newFeild] = [el.name]
          })
        }
      })
      this.pathNameArr = pathNameArr
    },

    // 下拉选择
    handleChange(value) {
      let factory = this.factoryData.find(item => item.factoryId == value)
      if (factory.overseasFlag != window.localStorage.getItem('overseasFlag')) {
        window.localStorage.setItem('overseasFlag', factory.overseasFlag)
      }
      window.localStorage.setItem("factoryId", value);
      window.localStorage.setItem("factory", JSON.stringify(factory));
      window.localStorage.setItem("factoryName", factory.name);
      let src = window.location.href
      if (src.indexOf('/mainPage/materialManagement/nutrient-list') >= 0) {
        this.$router.push('/mainPage/materialManagement?name=原料管理')
      } else if (src.indexOf('/mainPage/nutritional-indicator/index-view') >= 0) {
        this.$router.push('/mainPage/nutritional-indicator?name=营养指标管理')
      } else if (src.indexOf('/nhf-product/list/product-detail') >= 0) {
        this.$router.push('/nhf-product/list?name=产品记录')
      }
      setTimeout(() => {
        location.reload();
      }, 0);
    },
    //获取所有工厂数据
    async getFactory() {
      let params = {
        current: 1,
        size: 1000,
      };
      const res = await this.$http.get("/nhf-app/formulaManage/myFactory", { params })
      let { success, data } = res;
      if (success) {
        let { records } = data;
        this.factoryData = records || [];
        this.setState({ factoryData: records })
        this.filterFactoryList = [].concat(records || [])

      } else {
        this.$message.error("查询失败");
      }
    }

  },
}
</script>

<style lang='scss' scoped>
.tableBox1.tableBox {
  padding: 0;
}
.logo {
  margin: 0 auto;
  // width: 120px;
  height: 24px;
}
::v-deep .ant-layout-sider-children {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

// .collapsed{
//   .logo{
//     width:32px !important;
//   }
// }
.appBox {
  height: 100%;
}
.headBox {
  // height: 80px;
  height: 64px;
  width: 100%;
  background-color: transparent;
  border-bottom: 1px solid #f0f2f5;
  display: flex;
}
.bodyBox {
  display: flex;
  height: calc(100vh - 64px);
  // height: calc(100vh - 80px);
}
.menuBox {
  width: 256px;
  /* background-color: rgb(105, 120, 255); */
  height: 100%;
}
.contentBox {
  flex: 1;
  background-color: #f0f2f5;
  height: 100%;
  padding: 0 10px;
  overflow: auto;
}
.logoImg {
  width: 256px;
  font-weight: bold;
  color: #1998f7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  // border-right:1px solid #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  .ant-layout-sider-children {
    height: inherit;
    img {
      width: 120px;
    }
  }
}
.userBox {
  flex: 1;
  position: relative;
  display: flex;
  &-sider {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 15px;
    p {
      margin: 0;
      margin-left: 10px;
    }
  }
}
.userImg {
  // position: absolute;
  // right: 25px;
  // top: 23px;
  padding: 0 20px;
  cursor: pointer;
  // flex: 2;
}
.msgStyle {
  margin-top: 7px;
  // flex: 1;
  // position: absolute;
  // top: 6px;
  // right: 130px;
  cursor: pointer;
}
.userInfo {
  padding-bottom: 10px;
  p {
    color: gray;
    font-size: 14px;
    margin-bottom: 0px;
  }
}
.factoryNameText {
  cursor: pointer;
  margin: 0px -16px 2px;
  padding: 5px 30px;
  &:hover {
    background: #f5f7fa;
  }
}
.factoryChoice {
  background: #f5f7fa;
}
</style>
<style lang="scss">
.factoryList {
  .ant-popover-inner-content {
    padding: 8px 0;
  }
}
</style>
